__turbopack_context__.v({
  "component__btn": "vP9Ieq_component__btn",
});
